module.exports = __webpack_public_path__ + "static/ahmad-isber-abe37f164e034e24597091ed0fe32175.jpg";